import { Button, Grid, ScrollArea, Stack } from '@mantine/core';
import { useState } from 'react';

import { deleteIcon } from '@assets';
import { Table, TableColumnProps, TextInput } from '@components';

interface ExcludedListProps {
  name: string;
  inputPlaceholder: string;
  list: string[];
  onUpdate(updatedList: string[]): void;
  height?: string;
  fill?: boolean;
}

export const ExcludedList: React.FC<ExcludedListProps> = ({ list, onUpdate, name, inputPlaceholder, height, fill }) => {
  const [newValue, setNewValue] = useState('');
  const [rows, setRows] = useState(list.sort().slice());

  const removeItem = (row: string) => {
    const newRows = rows.filter((r) => r !== row);
    setRows(newRows);
    onUpdate(newRows);
  };

  const columns: TableColumnProps<any>[] = [
    {
      name,
      cell: (row) => row,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <Button type="button" onClick={() => removeItem(row)} size="lg" variant="transparent">
          <img src={deleteIcon} alt={'delete'} />
        </Button>
      ),
    },
  ];

  const onChange = (event: any) => {
    setNewValue(event.target.value);
  };

  const addItem = () => {
    if (rows.findIndex((r) => r === newValue) !== -1) {
      return;
    }

    const newRows = [...rows, newValue];
    onUpdate(newRows);
    setRows(newRows);
    setNewValue('');
  };

  return (
    <Stack mt="md" style={fill ? { flex: 1, minHeight: 0 } : undefined}>
      <ScrollArea
        h={fill ? undefined : height || '600px'}
        style={fill ? { flex: 1, minHeight: 0 } : undefined}
        offsetScrollbars="y"
        mb={fill ? undefined : 'xl'}
      >
        <Table columns={columns} dataSource={rows || []} verticalSpacing="xs" />
      </ScrollArea>
      <Grid>
        <Grid.Col span={9}>
          <TextInput label={inputPlaceholder} onChange={onChange} value={newValue} />
        </Grid.Col>
        <Grid.Col span={3}>
          <Button type="button" onClick={addItem} disabled={!newValue.length} variant="filled" size="lg">
            +
          </Button>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
